import { FunctionComponent } from 'react'
import styled, { useTheme, css } from 'styled-components'
import SvgIcon from '@components/SvgIcon'
import translate from '@i18n'
import { mobileCSS } from '@measures/responsive'
import { useFullScreenGallery } from '@hooks/useFullScreenGallery'

const CloseButtonWrapper = styled.button`
  ${({
    theme: {
      colors: { white },
    },
  }) => css`
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 0;
    width: 100%;
    padding: 0px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    color: ${white};
    cursor: pointer;
    z-index: 5;
    background-color: transparent;

    ${mobileCSS(css`
      position: absolute;
      top: 0;
      right: 0;
    `)}
  `}
`

const CloseButtonText = styled.div`
  ${({
    theme: {
      fonts: { sourceSansPro },
    },
  }) => css`
    font-family: ${sourceSansPro};
    font-size: 14px;
    padding-bottom: 10px;

    ${mobileCSS(css`
      display: none;
    `)}
  `}
`

const StyledCloseButton = styled(SvgIcon)`
  padding: 0 0 10px 10px;
  line-height: 0;

  ${mobileCSS(css`
    padding: 10px;
  `)};
`

interface CloseButtonProps {
  onClose: () => void
}

const CloseButton: FunctionComponent<CloseButtonProps> = ({ onClose }) => {
  const theme = useTheme()
  const { isFullScreen, hideFullScreenGalleryControls } = useFullScreenGallery()

  if (!isFullScreen || hideFullScreenGalleryControls) {
    return null
  }

  return (
    <CloseButtonWrapper onClick={onClose}>
      <CloseButtonText>{translate('gallery.closeFullscreen')}</CloseButtonText>
      <StyledCloseButton
        iconName="gallery-navigation-close"
        size={48}
        color={theme.colors.white}
      />
    </CloseButtonWrapper>
  )
}

export default CloseButton
